<div class="relative w-full h-full mx-auto" [style.max-width.px]="maxSize()" [style.max-height.px]="maxSize()">
  <div
    class="center-circle absolute h-[75%] w-[65%] rounded-full bg-[#2E353F]"
  ></div>
  <div id="radialChart" class="w-full h-full">
    @if (chartOptions && chartOptions.series && chartOptions.series.length > 0) {
    <apx-chart
      #radialChart
      [series]="chartOptions.series"
      [chart]="chartOptions.chart"
      [plotOptions]="chartOptions.plotOptions"
      [labels]="chartOptions.labels"
      [fill]="chartOptions.fill"
      [grid]="chartOptions.grid"
      [stroke]="chartOptions.stroke"
      [legend]="chartOptions.legend"
      [dataLabels]="chartOptions.dataLabels"
      [tooltip]="chartOptions.tooltip"
      [autoUpdateSeries]="false"
    ></apx-chart>
    }
  </div>
</div>
